import { RecipeVariants } from '@theme/utils/createRecipeObj';
import { createUseRecipeHook } from '@theme/utils/createUseRecipeHook';
import { root } from './Box.css';

export const useBoxStyle = createUseRecipeHook(root);
export type BoxStyleProps = RecipeVariants<typeof root>;
